import { render, staticRenderFns } from "./SihaoLayout.vue?vue&type=template&id=070d3662&scoped=true&"
import script from "./SihaoLayout.vue?vue&type=script&lang=js&"
export * from "./SihaoLayout.vue?vue&type=script&lang=js&"
import style0 from "./SihaoLayout.vue?vue&type=style&index=0&id=070d3662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d3662",
  null
  
)

export default component.exports